const Realize = {
	Form: window.Form,
	GridFilter: window.GridFilter
};

export default class GridFilter extends Realize.GridFilter {

	constructor(props) {
		super(props);
		this.renderFormFilters = this.constructor.prototype.renderFormFilters.bind(this);
	}

	renderFormFilters() {
		const FormComponent = this.props.formComponent || Realize.Form;

		return (
			<FormComponent {...this.props} otherButtons={[this.props.clearButton]} style="filter" ref="form" />
		)
	}
}
